import type { CometUserRoleType } from '@zg-rentals/ts-user-management-client';
import userUtils from '../utils/userUtils';

interface CompanyUserTypes {
  userName: string;
  email: string;
  userToken: string;
  userBrand: string;
  roleTypes: Array<CometUserRoleType>;
  propertyCount?: number;
  isCurrentUser: boolean;
  isPending: boolean;
  isAdmin: boolean;
  isApplicationManager: boolean;
  isPendingDelete: boolean;
  isPendingEdit: boolean;
  lastActivityTimestamp: string;
}

export const CompanyUser = ({
  userName = '',
  email = '',
  userToken = '',
  userBrand = '',
  roleTypes = [],
  propertyCount = 0,
  isCurrentUser = false,
  isPending = false,
  isAdmin = false,
  isApplicationManager = false,
  isPendingDelete = false,
  isPendingEdit = false,
  lastActivityTimestamp = '',
}: CompanyUserTypes) => ({
  userName: userName ? String(userName) : String(email).split('@')[0],
  email: String(email),
  userToken: String(userToken),
  userBrand: String(userBrand),
  permissions: userUtils.getFeaturePermissions(roleTypes),
  propertyCount: Number(propertyCount),
  isCurrentUser: Boolean(isCurrentUser),
  isPending: Boolean(isPending),
  isAdmin: Boolean(isAdmin),
  isApplicationManager: Boolean(isApplicationManager),
  isPendingDelete: Boolean(isPendingDelete),
  isPendingEdit: Boolean(isPendingEdit),
  lastActivityTimestamp: String(lastActivityTimestamp),
});

export default CompanyUser;
